module.exports = __webpack_public_path__ + "static/media/builtinv2-POtolok protyjka.fd2565cf.png";